import { combineReducers } from "@reduxjs/toolkit";
import { adminDetailsApi } from "./features/AdminDetailsAPI";
import { companySettingsApi } from "./features/CompanySetting";
import { equityBasketApi } from "./features/EquityBasketAPI";
import { importApi } from "./features/ImportAPI";
import { myWebsiteApi } from "./features/MyWebsite";
import { reportApi } from "./features/ReportAPI";
import { MFOrders } from "./features/MFOrders";
import { couponApi } from "./features/Revenue/CouponApi";
import { feeCalculationApi } from "./features/Revenue/FeeCalculationApi";
import { feePlanApi } from "./features/Revenue/FeePlan";
import { proformaApi } from "./features/Revenue/ProformaApi";
import { settingsApi } from "./features/SettingsApi";
import {
  appReducer,
  equityBasketReducer,
  exportReducer,
  myWebsiteReducer,
  mfOrdersReducer,
  portfolioReducer,
  tableReducer,
  userReducer,
} from "./slices";

const apis = [
  companySettingsApi,
  feePlanApi,
  feeCalculationApi,
  couponApi,
  proformaApi,
  myWebsiteApi,
  settingsApi,
  equityBasketApi,
  importApi,
  adminDetailsApi,
  reportApi,
  MFOrders,
];

// ---- Root Reducer ----
export const rootReducer = combineReducers({
  portfolio: portfolioReducer,
  app: appReducer,
  table: tableReducer,
  export: exportReducer,
  user: userReducer,
  equityBasket: equityBasketReducer,
  myWebsite: myWebsiteReducer,
  mfOrders: mfOrdersReducer,
  ...Object.fromEntries(apis.map((api) => [api.reducerPath, api.reducer])),
});

// ---- Middlewares ----
export const apiMiddlewares = apis.map((api) => api.middleware);
